import './metrics_per_agent/metrics_per_agent_chart_view.js.coffee'

class CustomerVisualMode.Charts.AverageReplyTimePerAgentBarChart extends CustomerVisualMode.Charts.MetricsPerAgentChartView
  template: JST['backbone/templates/customer_visual_mode/charts/average_reply_time_per_agent_bar_chart']
  className: 'grid-item full-width-chart average-reply-time-per-agent'
  @NAME: 'average_reply_time_per_agent'

  initialize: ({widget, title, dimensionName, description, data, session, isReadOnly, isResponsive}) ->
    super({
      widget,
      dimensionName: 'reply_time',
      templateTarget: '.average-reply-time-per-agent-metrics',
      description: I18n.t('customer_visual_mode.charts.average_reply_time_per_agent.description'),
      data,
      session,
      isReadOnly,
      isResponsive
    })

  toggleUseWorkCalendar: ->
    super()
    @currentDimension = @_workCalendarStrategy(@dimensionName, "#{@dimensionName}_without_work_calendar")

  _drilldownTitle: ->
    'Average response time'
